export default __webpack_public_path__ + "static/media/course-white.ad7c6235.svg";